import React from 'react';
import { Box, Typography } from '@mui/material';
import SidebarNavItem from '../SidebarNavItem';

// Ported from the senior's live startup-web (layout/Sidebar/components/SidebarNavigation.js).
// startup-web splits its nav across Fundraise / Relationships / Intelligence; the investor
// nav is a single flat list, so it renders under one "Workspace" section label.
const SectionLabel = ({ label, sidebarCollapsed }) => {
  if (sidebarCollapsed) return null;

  return (
    <Typography
      sx={{
        fontSize: '0.6875rem',
        fontWeight: 500,
        color: 'rgba(255,255,255,0.45)',
        letterSpacing: '0.25em',
        px: '0.875rem',
        pt: '1.25rem',
        pb: '0.25rem',
        display: 'block',
        userSelect: 'none',
        textTransform: 'uppercase',
      }}
    >
      {label}
    </Typography>
  );
};

// `sections` mirrors startup-web's menuConfig (Fundraise / Relationships / Intelligence):
// a labelled group per nav section, all inside one scroller.
//   sections = [{ label: 'Deal Flow', items: [...] }, ...]
// A section whose items are all permission-gated away renders nothing, label included.
const SidebarNavigation = ({
  sections = [],
  sidebarCollapsed = false,
  matchesUpMd,
  toggleDrawer,
}) => {
  const commonProps = {
    drawerToggle: !matchesUpMd ? toggleDrawer : undefined,
    collapsed: sidebarCollapsed,
  };

  return (
    <Box
      id="sidebar-scroller"
      sx={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
        pt: '0.25rem',
        pb: '0.25rem',
      }}
    >
      {sections.map((section) => {
        const visible = section?.items?.filter((item) => item?.permission !== false) || [];
        if (visible.length === 0) return null;
        return (
          <React.Fragment key={section.label}>
            <SectionLabel label={section.label} sidebarCollapsed={sidebarCollapsed} />
            {visible.map((item) => (
              <SidebarNavItem key={item.path || item.title} {...item} {...commonProps} />
            ))}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default SidebarNavigation;
